// extracted by mini-css-extract-plugin
export default {"Slide":"CategoRySlider_Slide__ZGJ8P","topLeft":"CategoRySlider_topLeft__u2BNS","img":"CategoRySlider_img__sbH3D","title":"CategoRySlider_title__D7yaU"};